/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetSummaryRequest {
    getFixupPrototypeFunction() { return BudgetSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<BudgetSummaryRequest>): BudgetSummaryRequest {
        let obj = Object.assign(new BudgetSummaryRequest(), model);
        BudgetSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetSummaryRequest>): BudgetSummaryRequest {
        if (!model) return null;
        return BudgetSummaryRequest.newInstance(<BudgetSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetSummaryRequest) {
        if (!obj) return;

        models.BudgetSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetSummaryRequest): boolean {
        Object.setPrototypeOf(obj, BudgetSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter_params) {
            models.BudgetSummaryFilterModel.fixupPrototype(this.filter_params);
        }
    }

    /**
     * filter budgets based on filter data
     */
    filter_params: models.BudgetSummaryFilterModel;

    /**
     * Tenant ids
     */
    tenant_ids: Array<string>;

    /**
     * Type of filter.Type will be budget_summary/alert_exceeds_summary
     */
    type: models.BudgetSummaryType;

}
